import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const SpendManagementCompany = (props) => (
	<ThemeContext.Provider
		value={{ linkText: "Visit Site", hasTrustPilotWidget: false }}
	>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
